module.exports = __webpack_public_path__ + "static/img/3.43ed50c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/zh/3.png
// module id = lhF3
// module chunks = 0